module.exports = __webpack_public_path__ + "img/male.e67e358c.png";